import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertTriangle, AlertCircle } from "lucide-react";

export default function QCIssueCard({ issue, onResolve }) {
  const severityConfig = {
    LOW: { icon: AlertCircle, className: "bg-blue-100 text-blue-800" },
    MEDIUM: { icon: AlertTriangle, className: "bg-yellow-100 text-yellow-800" },
    HIGH: { icon: AlertTriangle, className: "bg-red-100 text-red-800" },
  };

  const config = severityConfig[issue.severity] || severityConfig.MEDIUM;
  const Icon = config.icon;

  return (
    <Card
      data-testid={`qc-issue-${issue.id}`}
      className={`bg-white/80 backdrop-blur-sm border-2 transition-all ${
        issue.status === "RESOLVED"
          ? "border-green-200 bg-green-50/50"
          : "border-slate-200"
      }`}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Icon className="w-4 h-4" />
              <Badge className={config.className}>{issue.severity}</Badge>
              <Badge variant="outline">{issue.issue_type}</Badge>
              {issue.status === "RESOLVED" && (
                <Badge className="bg-green-100 text-green-800">Resolved</Badge>
              )}
            </div>

            <p className="text-sm text-black">{issue.description}</p>

            {issue.chapter_id && (
              <p className="text-xs text-slate-500 mt-1">
                Chapter: {issue.chapter_id}
              </p>
            )}
          </div>

          {issue.status === "OPEN" && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => onResolve(issue.id)}
              className="flex-shrink-0"
              data-testid={`resolve-issue-${issue.id}`}
            >
              <CheckCircle2 className="w-4 h-4 mr-1" />
              Mark Resolved
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
